import * as React from 'react';
import { Invoice } from '@services/payment/types/invoice';

import SubscriptionInvoiceItem from '../subscription-invoice-item';
import moment from 'moment';

interface SubscriptionInvoicesListProps {
  invoices: Invoice[];
}

const SubscriptionInvoicesList: React.FC<SubscriptionInvoicesListProps> = ({
  invoices,
}) => {
  return (
    <>
      {invoices.map((invoice, i) => (
        <SubscriptionInvoiceItem
          key={i}
          title={invoice.description}
          date={moment(invoice.invoice_date).format('LL')}
          isPaid={invoice.status === 'paid'}
          onClick={() => (invoice.url ? window.open(invoice.url) : null)}
        />
      ))}
    </>
  );
};

export default SubscriptionInvoicesList;
